import React from "react";
import SupportLayout from "../support/SupportLayout";
import SupportOfficerHomeContent from "../support-officer/components/SupportOfficerHomeContent";

const SupportManagerHome = () => {
  return (
    <SupportLayout userRole="SM">
      <SupportOfficerHomeContent userRole="SM" useOwnLayout={false} />
    </SupportLayout>
  );
};

export default SupportManagerHome;
